<template>
  <v-row>
    <v-col
      cols="12"
      lg="12"
    >
      <div class="d-flex align-center">
        <p class="font-weight-medium mr-3 mb-3">
          Edit profile:
        </p>
        <v-divider />
      </div>
      <base-card>
        <v-card-text>
          <div class="card-title">
            {{ user.username }}
          </div>
          <v-text-field
            v-model.trim="user.firstName"
            label="First Name"
            :counter="255"
          />
          <v-text-field
            v-model.trim="user.lastName"
            label="Last Name"
            :counter="255"
          />
        </v-card-text>
        <!-- Action button -->
        <div class="row text-right">
          <div class="col-md-2 col-l" />
          <div class="col-md-10">
            <v-btn
              text
              class="m-r-10"
              :loading="isSaving"
              color="primary"
              @click="changePasswordDialog = true"
            >
              <span>Set new password</span>
            </v-btn>
            <v-btn
              :loading="isSaving"
              color="success"
              @click="updateProfile"
            >
              <span>Save</span>
            </v-btn>
          </div>
        </div>
      </base-card>

      <!-- Change Password Dialog -->
      <v-dialog
        v-model="changePasswordDialog"
        max-width="500"
        persistent
      >
        <v-card>
          <v-form ref="form">
            <v-card-title class="text-h5">
              Set New Password
            </v-card-title>
            <v-card-text>
              <div class="row">
                <div class="col-md-12">
                  <v-text-field
                    v-model="newPassword"
                    :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="showNewPassword ? 'text' : 'password'"
                    name="new-password"
                    autocomplete="new-password"
                    label="New password*"
                    counter
                    @click:append="showNewPassword = !showNewPassword"
                  />
                  <v-text-field
                    v-model="confirmedPassword"
                    :append-icon="showConfirmedPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="showConfirmedPassword ? 'text' : 'password'"
                    name="confirmed-password"
                    autocomplete="new-password"
                    label="Confirm new password*"
                    counter
                    @click:append="showConfirmedPassword = !showConfirmedPassword"
                  />
                  <small
                    v-if="newPassword.length >= 6 && confirmedPassword.length >= 6 && newPassword !== confirmedPassword"
                    class="help-block form-text text-danger"
                  >
                    The passwords do not match
                  </small>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                depressed
                text
                @click="changePasswordDialog = false"
              >
                Cancel
              </v-btn>
              <v-btn
                :disabled="!isChangePasswordFormValid"
                color="success"
                @click="changePassword"
              >
                Change Password
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
  import { processUser, userToJsonAPI } from '@/store/converters'
  import { emailRegExp } from '@/helpers/utils'

  export default {
    name: 'Profile',
    data () {
      return {
        isSaving: false,
        newPassword: '',
        showNewPassword: false,
        confirmedPassword: '',
        showConfirmedPassword: false,
        changePasswordDialog: false,
        rules: {
          required: (value) => !!value || 'Required.',
          min: (v) => v.length >= 6 || 'Min 6 characters',
          // eslint-disable-next-line consistent-return
          email: (value) => {
            if (value.length > 0) {
              return emailRegExp.test(value) || 'Invalid e-mail'
            }
            return true
          },
        },
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      user () {
        return this.$store.getters.user ? processUser(this.$store.getters.user) : {}
      },
      isChangePasswordFormValid () {
        return this.newPassword.length >= 6 &&
          this.confirmedPassword.length >= 6 &&
          this.newPassword === this.confirmedPassword
      },
    },
    created () {},
    methods: {
      updateProfile () {
        this.isSaving = true

        this.$store.dispatch('updateUser', userToJsonAPI(this.user))
          .then(() => {
            this.isSaving = false
            this.$store.commit('showSnackbar', {
              text: 'Profile successfully updated',
              timeout: 6000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.isSaving = false
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      changePassword () {
        if (!this.isChangePasswordFormValid) {
          return
        }
        this.$store.dispatch('changeMyPassword', this.newPassword)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'Password successfully updated',
              timeout: 3000,
              color: 'success',
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$refs.form.reset()
            this.newPassword = ''
            this.confirmedPassword = ''
            this.changePasswordDialog = false
          })
      },
    },
  }
</script>
